import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import { AuthProvider, AuthContext } from "./context/AuthContext";
import { AppContextProvider } from "./context/AppContext";
import React, { useContext, Suspense } from "react";
import SignIn from "./pages/SignIn";
import PrivateRoute from "./components/PrivateRoute";
import ScrollToTop from "./components/ScrollToTop";
import Loader from "./components/Loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import Error from "./pages/Error";
import Profile from "./pages/Profile";
import ResetPassword from "./pages/ResetPassword";
import ActiveSession from "./pages/ActiveSession";
import Dashboard from "./pages/Dashboard";
import UserManager from "./pages/UserManager";
import DocumentCategoryManager from "./pages/DocumentCategoryManager";
import NotificationManager from "./pages/NotificationManager";
import ReportsAnalytics from "./pages/ReportAnalytics";
import ReferralCashbackManager from "./pages/ReferralCashbackManager";
import ContentManager from "./pages/ContentManager";
import TransactionManager from "./pages/TransactionManager";
import EmailTemplateManager from "./pages/EmailTemplateManager";
import KYCManagement from "./pages/KYCManagement";
import BannerManager from "./pages/BannerManager";
import SubAdminManager from "./pages/SubAdminManager";
import RolesPermissions from "./pages/RolesPermissions";
import WithdrawalRequestManager from "./pages/WithdrawalRequestManager";
import CompilanceManager from "./pages/CompilanceSystemManager"
import Support from "./pages/Support";
import Count from "./pages/RedirectURl";
import TrustAccountManager from "./pages/TrustAccountManager";
import SubscriptionPriceManager from "./pages/SubscriptionPriceManager";
import AuditLogsManager from "./pages/AuditLogsManager";
import InvoiceManager from "./pages/InvoiceManager";

window.Buffer = window.Buffer || require("buffer").Buffer;

function App() {
  return (
    <AuthProvider>
      <AppContextProvider>
        <Suspense fallback={<Loader />}>
          <BrowserRouter>
            <ScrollToTop />
            <ToastContainer closeOnClick={false} />
            <AppRoutes />
          </BrowserRouter>
        </Suspense>
      </AppContextProvider>
    </AuthProvider>
  );
}

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<SignIn />} />
      <Route path="/admin/reset-password/:id" element={<ResetPassword />} />
      <Route path="redirect-url" element={<Count />} />
      {/* Private Routes */}
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="profile" element={<Profile />} />
        <Route path="active-session" element={<ActiveSession />} />
        <Route path="user-manager" element={<UserManager />} />
        <Route path="sub-admin-manager" element={<SubAdminManager />} />
        <Route path="access-manager" element={<RolesPermissions />} />
        <Route path="document-category-manager" element={<DocumentCategoryManager />} />
        <Route path="withdrawal-request-manager" element={<WithdrawalRequestManager />} />
        <Route path="transaction-manager" element={<TransactionManager />} />
        <Route path="report-analytics" element={<ReportsAnalytics />} />
        <Route path="kyc-management" element={<KYCManagement />} />
        <Route path="referral-and-cashback" element={<ReferralCashbackManager />} />
        <Route path="banner-management" element={<BannerManager />} />
        <Route path="content-manager" element={<ContentManager />} />
        <Route path="notification-manager" element={<NotificationManager />} />
        <Route path="compliance-manager" element={<CompilanceManager />} />
        <Route path="email-template-manager" element={<EmailTemplateManager />} />
        <Route path="trust-account-manager" element={<TrustAccountManager />} />
        <Route path="support" element={<Support />} />
        <Route path="subscription-price-manager" element={<SubscriptionPriceManager />} />
        <Route path="audit-logs-manager" element={<AuditLogsManager />} />
        <Route path="invoice-manager" element={<InvoiceManager />} />
      </Route>

      {/* Catch All */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

const Layout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default App;
